export const TIMELINE_PREVIEW_CONTAINER_HEIGHT = 265  // Doubled for dual-layer (phases + tasks)
export const TIMELINE_PREVIEW_CONTENT_HEIGHT = 242    // Doubled for dual-layer (phases + tasks)

export const SELECT_CROP_TOOLTIP_TEXT = 'Please select a crop species first'

export const EXCLUDED_PHASE_TYPES = ['vegetative', 'budding', 'flowering', 'ripening']

export const SHOW_NUMERIC_SCHEDULE_DETAILS = false

// Task types available for crop schedules (crop-level only, no plot tasks)
// Each task requires a specific crop phase to exist in the schedule
export const CROP_TASK_TYPES = [
  { code: 'sow_indoor', name: 'Sow Indoor', description: 'Sow seeds indoors before transplanting', directSowOnly: false, requiredPhase: 'germination' },
  { code: 'transplant_indoor', name: 'Transplant Indoor', description: 'Move seedlings to larger containers indoors', directSowOnly: false, requiredPhase: 'seedling' },
  { code: 'transplant_outdoor', name: 'Transplant Outdoor', description: 'Transplant seedlings from indoors to outdoor plots', directSowOnly: false, requiredPhase: 'maturing' },
  { code: 'sow_outdoor', name: 'Sow Outdoor', description: 'Sow seeds directly in outdoor plots', directSowOnly: true, requiredPhase: 'germination' },
  { code: 'support', name: 'Support/Trellis', description: 'Install supports or trellises for growing plants', directSowOnly: null, requiredPhase: 'maturing' },
  { code: 'harvest', name: 'Harvest', description: 'Collect mature crops from the plot', directSowOnly: null, requiredPhase: 'mature' },
  { code: 'compost', name: 'Compost', description: 'Process plant biomass after harvest', directSowOnly: null, requiredPhase: 'decomposition' },
  { code: 'cut_back', name: 'Cut Back', description: 'Cut back and prepare the crop for winter', directSowOnly: null, requiredPhase: 'dormant' },
]

// Default tasks to include in schedule (commonly used tasks)
export const DEFAULT_TASK_CODES = ['sow_indoor', 'transplant_outdoor', 'harvest']
